function initSeenInKnya(root) {
  root.querySelectorAll('.seen-in-knya-grid').forEach(function (grid) {
    if (grid.dataset.seenInKnyaInit) return;
    grid.dataset.seenInKnyaInit = 'true';

    var track = grid.querySelector('.seen-in-knya-track');
    if (!track) return;

    var pxPerSecond = 22;
    var loopWidth = 0;
    var offset = 0;
    var lastTime = null;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartOffset = 0;
    var hasMoved = false;

    function measure() {
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      loopWidth = track.scrollWidth / 2 + gap;
    }

    function applyTransform() {
      if (loopWidth <= 0) return;
      var wrapped = ((offset % loopWidth) + loopWidth) % loopWidth;
      track.style.transform = 'translateX(' + -wrapped + 'px)';
    }

    function tick(time) {
      if (lastTime === null) lastTime = time;
      var delta = (time - lastTime) / 1000;
      lastTime = time;

      if (!isDragging) {
        offset += pxPerSecond * delta;
        applyTransform();
      }

      requestAnimationFrame(tick);
    }

    function getX(e) {
      return e.touches ? e.touches[0].clientX : e.clientX;
    }

    function onDragStart(e) {
      isDragging = true;
      hasMoved = false;
      dragStartX = getX(e);
      dragStartOffset = offset;
      grid.classList.add('is-dragging');
    }

    function onDragMove(e) {
      if (!isDragging) return;
      var delta = getX(e) - dragStartX;
      if (Math.abs(delta) > 3) hasMoved = true;
      offset = dragStartOffset - delta;
      applyTransform();
    }

    function onDragEnd() {
      isDragging = false;
      grid.classList.remove('is-dragging');
    }

    grid.addEventListener('mousedown', onDragStart);
    window.addEventListener('mousemove', onDragMove);
    window.addEventListener('mouseup', onDragEnd);

    grid.addEventListener('touchstart', onDragStart, {passive: true});
    grid.addEventListener('touchmove', onDragMove, {passive: true});
    grid.addEventListener('touchend', onDragEnd);

    grid.addEventListener(
      'click',
      function (e) {
        if (hasMoved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    measure();
    window.addEventListener('resize', measure);
    requestAnimationFrame(tick);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initSeenInKnya(document);
  });
} else {
  initSeenInKnya(document);
}

document.addEventListener('shopify:section:load', function (event) {
  initSeenInKnya(event.target);
});
